// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cooperation-systems-list[data-v-0e09c37c]{max-width:1080px;margin-left:auto;margin-right:auto}#cooperation-systems-list .box-header[data-v-0e09c37c]{width:100%}#cooperation-systems-list .box-header .title[data-v-0e09c37c]{font-size:22px;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
